import React from 'react'

/* mui */
import { makeStyles } from '@material-ui/core/styles'
/* mui */

/* CONSTANTS */
const useStyles = makeStyles(theme => ({
  wrapp: {
    textAlign: 'center',
    margin: theme.spacing(5),
  },
}))
/* CONSTANTS */

const index = props => {
  /* mui */
  const classes = useStyles()
  /* mui */

  return <div className={classes.wrapp}>{props.children}</div>
}

export default index
